/*----- Core -----*/
import React, { useEffect, useState } from 'react'
import { connect } 					from "react-redux"

/*----- Styles -----*/
import Styles from './Styles'

/*----- Assets -----*/
import circleAndLines from '../../assets/producers/circle_and_lines.svg'

/*----- Ant design -----*/
import { Row, Col, Pagination } from 'antd'

/*----- Utils -----*/
import stringTitleCase from '../../utils/StringTitleCase'

/*----- Components -----*/
import SectionContainer    from '../../components/commons/SectionContainer'
import ProducerCard	       from '../../components/card/ProducerCard'
import HeroText				     from '../../components/hero/HeroText'
import ParagraphWithShadow from '../../components/text/ParagraphWithShadow'
import Modal 							 from '../../components/Modal'
import Person 						 from '../../components/Person'
import Spinner 						 from '../../components/commons/Spinner'
import CardListContainer   from '../../components/commons/CardListContainer'
import SearchInput 			   from '../../components/search/SearchInput'

/*----- Selectors -----*/
import { 
	listIsloadingSelector, 
	listSelector,
	loadCompletedSelector ,
} from '../admin/producers/read/Selectors'

import { modalDataSelector }   from '../../modules/app/Selectors'

/*----- Actions  -----*/
import { getProducers, redirect } from '../admin/producers/read/Actions'
import { toggleModal }   from '../../modules/app/Actions'

function Producers({ 
	getProducers, 
	listIsLoading, 
	producersData,
	loadCompleted,
	toggleModal,
	modalData
 }) {

	const INITIAL_PAGINATOR       			    	= { minValue: 0, maxValue: 12}
	const [searchResults, setSearchResults ]	= useState(null)

	const NUEM_EACH_PAGE 	 = 12
	const [page, setPage]  = useState(INITIAL_PAGINATOR)

	useEffect(() => {
		if (!loadCompleted) {
			getProducers()
		}
	},[getProducers,loadCompleted])

	const handlePageChange = (value) => {
		setPage({
			minValue: (value - 1) * NUEM_EACH_PAGE,
			maxValue: value * NUEM_EACH_PAGE
		})
	}

	const onSearchChange = (e) => {
		let value = e.target.value
		if (value.length >=3) {
			const results = producersData.list.filter((e)=>{
				return  e.lastname.includes(value) || e.lastname.includes(stringTitleCase(value)) || e.lastname.includes(value.toUpperCase())
			})
			setSearchResults(results)
		} else {
			setSearchResults(null)
		}
	}

	const renderProducerList = () => {
		if (producersData === null || listIsLoading ) {
			return (
				<Styles>
					<div className="spinner-container">
						<Spinner/>
					</div>
				</Styles>
			)
		}
		else if (searchResults) {
			return (
				<>
					<CardListContainer>
						{
							searchResults
							.filter( p => p.visible )
							.map((p, i)=>{
								let { name, lastname, images, communication_channels, mat_number } = p
								return (
										<ProducerCard
											key        = { mat_number + i }
											name  	   = { name }
											lastname   = { lastname }
											mat_number = { mat_number }
											imageUrl 	 = { images }
											email    	 = { communication_channels }
											onClick  	 = { ()=> toggleModal(p.id) }
										/>
									)
							})
						}
					</CardListContainer>
					<div className="paginator-container">
						<Pagination 
							defaultCurrent	= {1}
							defaultPageSize = {NUEM_EACH_PAGE}
							onChange			  = {(value)=>handlePageChange(value)}
							total						= {producersData.itemsSize}
							showSizeChanger = {false}
							responsive      
						/>
					</div>
				</>
			)
		}
		return (
			<>
				<CardListContainer>
					{
						producersData.list
						.filter( p => p.visible )
						.slice(page.minValue, page.maxValue)
						.map((p, i)=>{
							let { name, lastname, images, communication_channels, mat_number } = p
							return (
									<ProducerCard
										key        = { mat_number + i }
										name  	   = { name }
										lastname   = { lastname }
										mat_number = { mat_number }
										imageUrl 	 = { images }
										email    	 = { communication_channels }
										onClick  	 = { ()=> toggleModal(p.id) }
									/>
								)
						})
					}
				</CardListContainer>
				<div className="paginator-container">
					<Pagination 
						defaultCurrent	= {1}
						defaultPageSize = {NUEM_EACH_PAGE}
						onChange			  = {(value)=>handlePageChange(value)}
						total						= {producersData.itemsSize}
						showSizeChanger = {false}
						responsive      
					/>
				</div>
			</>
		)
	}

	function renderModal() {
		if (modalData && producersData.list) {
			let producer = producersData.list.find(element => element.id === modalData)
			return (
				<Modal
					styles={{ 
						maxWidth: '600px', 
						width:    '100%',
						borderRadius: '10px'
					}}
				>
					<Person
						fullname               = {`${ producer.name } ${producer.lastname}`}
						imageUrl               = { producer.images }
						phone                  = { `${ producer.business_phone.area_code } ${ producer.business_phone.number }` }
						snn                    = { producer.mat_number }
						communication_channels = { producer.communication_channels }
					/>
				</Modal> 
			)
		}
	}
	return (
		<Styles>
			{ renderModal() }
			<div className="hero-container">
				<SectionContainer>
					<Row>
						<Col xs={24} sm={24} md={24} xl={12} xxl={12}>
							<HeroText 
								title    = "Conocé a nuestros productores"
								subtitle = "¿Buscás asesoramiento para analizar los riesgos a los que estás expuesto? ¡Contactalos!"
								invert   = { true }
							/>
						</Col>
					</Row>
				</SectionContainer>
				<div className="circle-container">
					<img src={ circleAndLines } className="circle-container__blue-circle" alt=""/>
				</div>
			</div>

			<SectionContainer>
				<div className="greeting-paragraph">
					<ParagraphWithShadow content="Cada uno de nuestros productores cuenta con matrícula profesional para operar otorgada por la Superintendencia de Seguros de la Nación y se encuentra calificado para brindarte asesoramiento acerca de la mejor manera de proteger tu patrimonio y tu futuro."/>
				</div>
				<SearchInput placeholder="Buscar por apellido" onChange={onSearchChange} noRender data={searchResults} />
				<div className="producer-list">
					<Col xs={24}>
						{ renderProducerList() }
					</Col>
				</div>	
			</SectionContainer>

		</Styles>
	)
}

const mapStateToProps = (state) => {
	return {
		listIsLoading:      listIsloadingSelector(state),
		producersData:		  listSelector(state),
		loadCompleted:      loadCompletedSelector(state),
		modalData:          modalDataSelector(state),
		route:              state.router
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
		getProducers:    	 (params) => getProducers(dispatch, params),
		toggleModal:       (data) => toggleModal(dispatch, data),
		redirect:          (params) => redirect(dispatch, params)
	}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Producers)
